import { render, staticRenderFns } from "./CertificadoFse.vue?vue&type=template&id=9bb3d282&"
import script from "./CertificadoFse.vue?vue&type=script&lang=js&"
export * from "./CertificadoFse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports